// /home/szymon/kreator2/frontend/src/components/editor/Transforms.js
function getCorners(obj) {
  const { x, y, width, height, offsetX, offsetY, scaleX, scaleY, rotation } = obj;
  const rotRad = (rotation * Math.PI) / 180;
  const transformPoint = (localX, localY) => {
    const dx = localX - offsetX;
    const dy = localY - offsetY;
    const sx = dx * scaleX;
    const sy = dy * scaleY;
    const rx = sx * Math.cos(rotRad) - sy * Math.sin(rotRad);
    const ry = sx * Math.sin(rotRad) + sy * Math.cos(rotRad);
    return {
      gx: x + rx,
      gy: y + ry
    };
  };
  const cornersLocal = [
    { name: "TL", lx: 0, ly: 0 },
    { name: "TR", lx: width, ly: 0 },
    { name: "BR", lx: width, ly: height },
    { name: "BL", lx: 0, ly: height }
  ];
  return cornersLocal.map((c) => {
    const { gx, gy } = transformPoint(c.lx, c.ly);
    return { cornerName: c.name, x: gx, y: gy };
  });
}

export function handleRotate(obj, angleDelta, onChangeImage, onChangeSvg, onChangeText) {
  if (!obj) return;
  const {
    id,
    x,
    y,
    width,
    height,
    rotation = 0,
    scaleX = 1,
    scaleY = 1,
    offsetX = 0,
    offsetY = 0
  } = obj;
  console.log(
    "[handleRotate] BEFORE [id=" + id + "]",
    "x=" + x.toFixed(2),
    "y=" + y.toFixed(2),
    "w=" + width.toFixed(2),
    "h=" + height.toFixed(2),
    "rot=" + rotation,
    "scaleX=" + scaleX.toFixed(2),
    "scaleY=" + scaleY.toFixed(2),
    "offsetX=" + offsetX.toFixed(2),
    "offsetY=" + offsetY.toFixed(2)
  );
  const cornersBefore = getCorners(obj);
  cornersBefore.forEach((c) => {
    console.log(
      "[handleRotate] BEFORE corner",
      c.cornerName,
      "= (" + c.x.toFixed(2) + ", " + c.y.toFixed(2) + ")"
    );
  });
  const radOld = (rotation * Math.PI) / 180;
  const dxOld = offsetX * scaleX;
  const dyOld = offsetY * scaleY;
  const oldCenterX = x + (dxOld * Math.cos(radOld) - dyOld * Math.sin(radOld));
  const oldCenterY = y + (dxOld * Math.sin(radOld) + dyOld * Math.cos(radOld));
  const newRotation = rotation + angleDelta;
  let finalRotation = newRotation % 360;
  if (finalRotation < 0) {
    finalRotation += 360;
  }
  const newOffsetX = width / 2;
  const newOffsetY = height / 2;
  const radNew = (finalRotation * Math.PI) / 180;
  const dxNew = newOffsetX * scaleX;
  const dyNew = newOffsetY * scaleY;
  const newCenterDx = dxNew * Math.cos(radNew) - dyNew * Math.sin(radNew);
  const newCenterDy = dxNew * Math.sin(radNew) + dyNew * Math.cos(radNew);
  const newX = oldCenterX - newCenterDx;
  const newY = oldCenterY - newCenterDy;
  const changeObj = {
    id,
    x: newX,
    y: newY,
    rotation: finalRotation,
    offsetX: newOffsetX,
    offsetY: newOffsetY
  };
  if (obj._type === "image") {
    onChangeImage?.(changeObj);
  } else if (obj._type === "svg") {
    onChangeSvg?.(changeObj);
  } else if (obj._type === "text") {
    onChangeText?.(changeObj);
  }
  console.log(
    "[handleRotate] AFTER [id=" + id + "]",
    "x=" + newX.toFixed(2),
    "y=" + newY.toFixed(2),
    "w=" + width.toFixed(2),
    "h=" + height.toFixed(2),
    "rot=" + finalRotation,
    "scaleX=" + scaleX.toFixed(2),
    "scaleY=" + scaleY.toFixed(2),
    "offsetX=" + newOffsetX.toFixed(2),
    "offsetY=" + newOffsetY.toFixed(2)
  );
  const afterObj = {
    ...obj,
    x: newX,
    y: newY,
    rotation: finalRotation,
    offsetX: newOffsetX,
    offsetY: newOffsetY
  };
  const cornersAfter = getCorners(afterObj);
  cornersAfter.forEach((c) => {
    console.log(
      "[handleRotate] AFTER corner",
      c.cornerName,
      "= (" + c.x.toFixed(2) + ", " + c.y.toFixed(2) + ")"
    );
  });
}

export function handleFlipX(obj, onChangeImage, onChangeSvg, onChangeText) {
  if (!obj) return;
  const {
    id,
    x,
    y,
    width,
    height,
    rotation = 0,
    scaleX = 1,
    scaleY = 1
  } = obj;
  console.log(
    "[handleFlipX] BEFORE [id=" + id + "]",
    "x=" + x.toFixed(2),
    "y=" + y.toFixed(2),
    "w=" + width.toFixed(2),
    "h=" + height.toFixed(2),
    "rot=" + rotation,
    "scaleX=" + scaleX.toFixed(2),
    "scaleY=" + scaleY.toFixed(2)
  );
  const cornersBefore = getCorners(obj);
  cornersBefore.forEach((c) => {
    console.log(
      "[handleFlipX] BEFORE corner",
      c.cornerName,
      "= (" + c.x.toFixed(2) + ", " + c.y.toFixed(2) + ")"
    );
  });
  const oldRotation = rotation;
  const radOld = (oldRotation * Math.PI) / 180;
  const newOffsetX = width / 2;
  const newOffsetY = height / 2;
  const oldDx = obj.offsetX * scaleX;
  const oldDy = obj.offsetY * scaleY;
  const oldCenterX = x + (oldDx * Math.cos(radOld) - oldDy * Math.sin(radOld));
  const oldCenterY = y + (oldDx * Math.sin(radOld) + oldDy * Math.cos(radOld));
  const newScaleY = -scaleY;
  const dxNew = newOffsetX * scaleX;
  const dyNew = newOffsetY * newScaleY;
  const newCenterDx = dxNew * Math.cos(radOld) - dyNew * Math.sin(radOld);
  const newCenterDy = dxNew * Math.sin(radOld) + dyNew * Math.cos(radOld);
  const newX = oldCenterX - newCenterDx;
  const newY = oldCenterY - newCenterDy;
  const changeObj = {
    id,
    x: newX,
    y: newY,
    offsetX: newOffsetX,
    offsetY: newOffsetY,
    scaleY: newScaleY
  };
  if (obj._type === "image") {
    onChangeImage?.(changeObj);
  } else if (obj._type === "svg") {
    onChangeSvg?.(changeObj);
  } else if (obj._type === "text") {
    onChangeText?.(changeObj);
  }
  console.log(
    "[handleFlipX] AFTER [id=" + id + "]",
    "x=" + newX.toFixed(2),
    "y=" + newY.toFixed(2),
    "scaleY=" + newScaleY.toFixed(2),
    "offsetX=" + newOffsetX.toFixed(2),
    "offsetY=" + newOffsetY.toFixed(2)
  );
  const afterObj = {
    ...obj,
    x: newX,
    y: newY,
    offsetX: newOffsetX,
    offsetY: newOffsetY,
    scaleY: newScaleY
  };
  const cornersAfter = getCorners(afterObj);
  cornersAfter.forEach((c) => {
    console.log(
      "[handleFlipX] AFTER corner",
      c.cornerName,
      "= (" + c.x.toFixed(2) + ", " + c.y.toFixed(2) + ")"
    );
  });
}

export function handleFlipY(obj, onChangeImage, onChangeSvg, onChangeText) {
  if (!obj) return;
  const {
    id,
    x,
    y,
    width,
    height,
    rotation = 0,
    scaleX = 1,
    scaleY = 1
  } = obj;
  console.log(
    "[handleFlipY] BEFORE [id=" + id + "]",
    "x=" + x.toFixed(2),
    "y=" + y.toFixed(2),
    "w=" + width.toFixed(2),
    "h=" + height.toFixed(2),
    "rot=" + rotation,
    "scaleX=" + scaleX.toFixed(2),
    "scaleY=" + scaleY.toFixed(2)
  );
  const cornersBefore = getCorners(obj);
  cornersBefore.forEach((c) => {
    console.log(
      "[handleFlipY] BEFORE corner",
      c.cornerName,
      "= (" + c.x.toFixed(2) + ", " + c.y.toFixed(2) + ")"
    );
  });
  const oldRotation = rotation;
  const radOld = (oldRotation * Math.PI) / 180;
  const newOffsetX = width / 2;
  const newOffsetY = height / 2;
  const oldDx = obj.offsetX * scaleX;
  const oldDy = obj.offsetY * scaleY;
  const oldCenterX = x + (oldDx * Math.cos(radOld) - oldDy * Math.sin(radOld));
  const oldCenterY = y + (oldDx * Math.sin(radOld) + oldDy * Math.cos(radOld));
  const newScaleX = -scaleX;
  const dxNew = newOffsetX * newScaleX;
  const dyNew = newOffsetY * scaleY;
  const newCenterDx = dxNew * Math.cos(radOld) - dyNew * Math.sin(radOld);
  const newCenterDy = dxNew * Math.sin(radOld) + dyNew * Math.cos(radOld);
  const newX = oldCenterX - newCenterDx;
  const newY = oldCenterY - newCenterDy;
  const changeObj = {
    id,
    x: newX,
    y: newY,
    offsetX: newOffsetX,
    offsetY: newOffsetY,
    scaleX: newScaleX
  };
  if (obj._type === "image") {
    onChangeImage?.(changeObj);
  } else if (obj._type === "svg") {
    onChangeSvg?.(changeObj);
  } else if (obj._type === "text") {
    onChangeText?.(changeObj);
  }
  console.log(
    "[handleFlipY] AFTER [id=" + id + "]",
    "x=" + newX.toFixed(2),
    "y=" + newY.toFixed(2),
    "scaleX=" + newScaleX.toFixed(2),
    "offsetX=" + newOffsetX.toFixed(2),
    "offsetY=" + newOffsetY.toFixed(2)
  );
  const afterObj = {
    ...obj,
    x: newX,
    y: newY,
    offsetX: newOffsetX,
    offsetY: newOffsetY,
    scaleX: newScaleX
  };
  const cornersAfter = getCorners(afterObj);
  cornersAfter.forEach((c) => {
    console.log(
      "[handleFlipY] AFTER corner",
      c.cornerName,
      "= (" + c.x.toFixed(2) + ", " + c.y.toFixed(2) + ")"
    );
  });
}
